import { ACTION_ADD_WORDPRESS_CONTENTS } from "../action";

const reduceWordPress = (state = {}, action)=>{
	switch (action.type) {
		case ACTION_ADD_WORDPRESS_CONTENTS:
			let newState = {...state}
			for(let content of action.payload){
				newState = {
					...newState,
					[content.ID]: content,
				}
			}
			return newState
	}
	return state;
};

export default reduceWordPress;